import StateStoreBase from "./StateStoreBase.js";
class RenewingSessionStore extends StateStoreBase {
  constructor() {
    super(...arguments);
    this.isRenewing = false;
  }
  get() {
    return this.isRenewing;
  }
  set(isRenewing) {
    this.isRenewing = isRenewing;
    this.notifySubscribers();
  }
}
const renewingSessionStore = new RenewingSessionStore();
export {
  RenewingSessionStore,
  renewingSessionStore as default
};
//# sourceMappingURL=renewingSessionStore.js.map
